import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ chapter, title, note }) => (
  <Reveal className="mb-12 sm:mb-16">
    <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400/90 mb-4">{chapter}</p>
    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-none max-w-2xl">
        {title}
      </h2>
      {note && <p className="text-sm text-zinc-500 max-w-xs lg:text-right">{note}</p>}
    </div>
    <div className="mt-6 h-px w-full bg-gradient-to-r from-amber-400/60 via-border to-transparent" />
  </Reveal>
);
